const VIDEO_TUTORIALS = {
  concurrentEvents: {
    id: "vt-04",
    title: "event:host.concurrent.events",
    url: "https://www.youtube.com/embed/lhnlOncPcUU",
  },
  customFloorPlan: {
    id: "vt-16",
    title: "event:create.custom.floor.plans",
    url: "https://www.youtube.com/embed/8mht1xhUp5A",
  },
  privateEvent: {
    id: "vt-06",
    title: "event:host.private.event.remo",
    url: "https://www.youtube.com/embed/JmAeG7DvphY",
  },
};

export default VIDEO_TUTORIALS;
